const blog = {
  title: 'PEGASUS ARMS блог',
  socLinks: 'Ми в соцмережах',
  back: 'Назад',
  more: "Детальніше",
  all: 'Всі статті',
  interested: 'Вас може зацікавити',
  articleZero: {
    date: '25.12.2025',
    title: 'Навчений екіпаж — результативні вильоти: як готують операторів дронів Pegasus Arms 25',
    paragraphs: [
      'Навчитись літати на дроні — справа не важка. Важко навчитись літати так — щоб кількість злетів дорівнювала кількості посадок, а кожен виліт був результативним. Саме цьому навчають у "НЦВТ МІСТ" — приватному закладі, що готує пілотів важких дронів-бомберів, як от наш Pegasus Arms 25.',
      'Щоб стати сертифікованим пілотом важкого дрону потрібно три тижні. За цей час екіпаж проходить повний курс навчання, що включає:',
      
      ],
    lists: {
      items: [
        '▪️ 48 академічних годин теорії та практики;',
        '▪️ 48 годин льотної підготовки;',
        '▪️ керування ударними БпАК PEGASUS ARMS 25 із різними типами корисного навантаження;',
        '▪️ виконання бойових завдань та роботу в складних погодних умовах;',
        '▪️ протидію ворожим дронам та застосування РЕБ/РЕР, антидронових засобів.',
      ],
      },
    links: {
      title:
        'Як проходить процес навчання — розповіли у сюжеті журналісти програми Факти ICTV:',
      link: 'https://youtu.be/rm4wzWsdpsw?si=QqyU4k270yRlA02S',
    },
  },
  articleOne: {
    date: '23.10.2025',
    title: 'КОЖЕН ГВИНТИК ВАЖЛИВИЙ. ЯК І ТИ – У КОМАНДІ PEGASUS ARMS.',
    paragraphs: [
      'Ми працюємо там, де важлива точність. Де кожен міліметр і кожен рух мають вирішальне значення.',
      'Якщо ти мислиш системно, цінуєш якість і бажаєш зростати в miltech-напрямку — приєднуйся до нас.',
      'Ми розширюємо команду і шукаємо тих, хто не просто хоче працювати — а прагне створювати перевагу, тримати небо і змінювати правила гри.',
    ],
    lists: {
      title: 'Наші переваги:',
      items: [
        '️▪️ Офіційне працевлаштування',
        '▪️ Бронювання співробітників',
        '▪️ Гідна заробітна плата',
        '▪️ Комфортні умови праці',
        '▪️ Навчання та підтримка',
        '▪️ Відпустка 24 календарних дні',
        '▪️ Оплата лікарняних',
      ],
    },
    links: {
      title:
        '🗂️Повний перелік вакансій дивіться за посиланням на DOU у шапці профілю',
      link: 'https://jobs.dou.ua/companies/tov-pegas-arms/vacancies/',
    },
  },
  articleTwo: {
    date: '23.10.2025',
    title: 'Чому Pegasus Arms 25 стійкий до радіоелектронного впливу?',
    paragraphs: [
      '«ВАШ ДРОН «ПОСАДИТЬ» ПЕРША Ж РЕБ!», — вважають ті, хто бачив БпЛА лише у соцмережах та плутає Pegasus Arms 25 із іншими безпілотниками',
      'Насправді — ні.',
      'Він не втрачає керування та не «сідає в кукурудзу», коли потрапляє під вплив РЕБ.',
      'Чому Pegasus Arms 25 стійкий до радіоелектронного впливу?',
      '➡️ ЧАСТОТНА МАНЕВРЕНІСТЬ: працює в спектрі частот, які складно відстежити. Якщо сигнал «глушиться» — дрон автоматично переходить на іншу частоту.',
      '➡️ СТІЙКЕ ШИФРУВАННЯ: захищений канал управління унеможливлює перехоплення чи втручання ворога.',
      '➡️ ПІДТРИМКА ПІЛОТА: в зоні потужної РЕБ дрон зберігає керування та здатність працювати під завадами.',
      '️➡️ АДАПТАЦІЯ ПІД МІСІЮ: перед кожним польотом система підлаштовується під тип загроз, місцевість та рівень радіоелектронного впливу.',
      'Головне — не просто запустити дрон, а щоб він виконав місію та повернувся.',
      'Pegasus Arms 25 — ударний дрон, який це зробив уже десятки разів.',
    ],
  },
}
export default blog
